import { render, staticRenderFns } from "./BatchEnrollmentStatusDialog.vue?vue&type=template&id=246b7214&scoped=true"
import script from "./BatchEnrollmentStatusDialog.vue?vue&type=script&lang=js"
export * from "./BatchEnrollmentStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchEnrollmentStatusDialog.vue?vue&type=style&index=0&id=246b7214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b7214",
  null
  
)

export default component.exports